const data = navigator.userAgentData?.platform || navigator.platform;

export const isMac = () => data.toLowerCase().includes('mac');
